export const MENTAL_SKILLS_HEADINGS = [
  "1. Self-Discovery",
  "2. Foundation Skills",
  "3. Performance Psychology - Part 1",
  "4. Performance Psychology - Part 2",
]
